import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';

import { showMsg } from '../../services/library';
import importDMSService from '../../services/importDMSService';

const REQ_IMPORTDMS = 'importDMS/';

export const createNEditImportDMSReq = createAsyncThunk(
  `${REQ_IMPORTDMS}createImportDMS`,
  async ({ obj }, { rejectWithValue }) => {
    try {
      const response = await importDMSService.createImportDMS(obj);
      if (response?.status) {
        showMsg(response.data[0]?.message, 'success');
        return { insertedData: response.data[0], status: response?.status };
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const listImportDMSReq = createAsyncThunk(
  `${REQ_IMPORTDMS}listImportDMS`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await importDMSService.listImportDMS();
      if (response?.status) {
        return response.data;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const deleteImportDMSReq = createAsyncThunk(
  `${REQ_IMPORTDMS}deleteImportDMS`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await importDMSService.deleteImportDMS({
        id: data?.importdms_id
      });
      if (response?.status) {
        showMsg(response?.message, 'success');
        return response;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const reloadInventoryReq = createAsyncThunk(
  `${REQ_IMPORTDMS}reloadInventory`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await importDMSService.reloadInventory({
        id: data.importdms_id
      });
      if (response?.status) {
        showMsg(response?.message, 'success');
        return response;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  importDMSTabs: true,
  importDMSId: 0,
  importDMSList: [],
  txtDMSName: '',
  txtDMSSlug: '',
  txtDMSAbbreviation: ''
};

const ImportDMSSlice = createSlice({
  name: 'importDMS',
  initialState,
  reducers: {
    handleEditData: {
      reducer(state, action) {
        const { importDMSTabs } = current(state);
        const { importdms_id, importdms_name, importdms_slug, importdms_abbreviation } = action.payload || {};
        state.importDMSId = importdms_id;
        state.txtDMSName = importdms_name;
        state.txtDMSSlug = importdms_slug;
        state.txtDMSAbbreviation = importdms_abbreviation;
        state.importDMSTabs = !importDMSTabs;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleResetStates: {
      reducer(state) {
        const { importDMSTabs } = current(state);
        state.importDMSTabs = !importDMSTabs;
        state.importDMSId = 0;
        state.txtDMSName = '';
        state.txtDMSSlug = '';
        state.txtDMSAbbreviation = '';
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleImportDMSTabs: {
      reducer(state, action) {
        state.importDMSTabs = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handelImportDMSList: {
      reducer(state, action) {
        state.importDMSList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtDMSName: {
      reducer(state, action) {
        state.txtDMSName = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtDMSSlug: {
      reducer(state, action) {
        state.txtDMSSlug = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtDMSAbbreviation: {
      reducer(state, action) {
        state.txtDMSAbbreviation = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(listImportDMSReq.pending, state => {
        state.importDMSList = [];
      })
      .addCase(listImportDMSReq.fulfilled, (state, action) => {
        const data = action.payload;
        state.importDMSList = data;
      })
      .addCase(listImportDMSReq.rejected, state => {
        state.importDMSList = [];
      });
  }
});

export const {
  handleResetStates,
  handleEditData,
  handleImportDMSTabs,
  handleTxtDMSName,
  handleTxtDMSSlug,
  handleTxtDMSAbbreviation,
  handelImportDMSList
} = ImportDMSSlice.actions;
export default ImportDMSSlice.reducer;
